export const dashify = (input?: string): string =>
  input ? input.toLocaleLowerCase().split(' ').join('-') : ''

export const undashifyAndCapitalise = (input?: string) =>
  input ? input.replace(/-/g, ' ').replace(/^./, input[0].toUpperCase()) : ''
